export default function SupportDocs() {
    return (
        <div className="p-6 space-y-8">
            <div className="mb-6">
                <h1 className="text-h2 text-text-primary">Support / Docs</h1>
                <p className="text-body-sm text-text-secondary mt-1">
                    Documentation and support resources
                </p>
            </div>

            {/* User Docs */}
            <section id="user-docs" className="card space-y-4">
                <h3 className="text-h4 text-text-primary">
                    User Documentation
                </h3>

                <p className="text-body-sm text-text-secondary">
                    End-user guides, tutorials, and FAQs will appear here.
                </p>
                <ul className="list-disc list-inside space-y-1 text-body-sm text-text-muted">
                    <li>Getting Started</li>
                    <li>Managing Clients & Projects</li>
                    <li>Uploading Generation Profiles</li>
                </ul>
            </section>

            {/* Developer Docs */}
            <section id="developer-docs" className="card space-y-4">
                <h3 className="text-h4 text-text-primary">
                    Developer Documentation
                </h3>

                <p className="text-body-sm text-text-secondary">
                    API reference, authentication, examples, and webhooks will appear here.
                </p>
                <ul className="list-disc list-inside space-y-1 text-body-sm text-text-muted">
                    <li>REST API Reference</li>
                    <li>Authentication & API Keys</li>
                    <li>Webhooks & Callbacks</li>
                </ul>
            </section>
        </div>
    );
}
